<script lang="ts">
  import { icons } from './icons.js'

  const { class: class_name, name } = $props<{ class: string, name: keyof typeof icons }>()
</script>

{@html icons[name](class_name)}